/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import './get_sales_tax_entries';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "service": {
                "nested": {
                  "SalesTaxService": {
                    "methods": {
                      "GetSalesTaxEntries": {
                        "requestType": ".squareup.sfs.external.service.GetSalesTaxEntriesRequest",
                        "responseType": ".squareup.sfs.external.service.GetSalesTaxEntriesResponse"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.SalesTaxService) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc External RPCs for Sales Tax Entries
 * --
 *
 * SOURCE SalesTaxService @ squareup/sfs/external/services/tax/sales_tax_service.proto at 11:1
 */
export const SalesTaxService = $root.lookupService('squareup.sfs.external.service.SalesTaxService');